const locale = {
    placeholder: 'Seleccionar hora',
    rangePlaceholder: ['Hora de inicio', 'Hora de fin'],
};
export default locale;
